import { useCallback } from "react";
import { NavigateOptions, useNavigate } from "react-router";
import { useFlowType } from "./useFlowType";
import { useToastsContext } from "./useToasts";

interface NavigateWithSearchOptions extends NavigateOptions {
  /** Go to the path as given, even from an OLB page. For web-only routes like membership share. */
  skipOlbRewrite?: boolean;
}

function useNavigateWithSearch() {
  const navigate = useNavigate();
  const flowType = useFlowType();
  const { clearToasts } = useToastsContext();

  const navigateWithSearch = useCallback(
    (path: string, { skipOlbRewrite = false, ...options }: NavigateWithSearchOptions = {}) => {
      const adjustedPath =
        flowType === "olb" && !skipOlbRewrite && path.startsWith("/")
          ? path.replace(/\/(credit-card|personal-loan|auto-loan)/, "/olb-$1")
          : path;

      clearToasts();

      return navigate(
        {
          pathname: adjustedPath,
          search: window.location.search,
        },
        options
      );
    },
    [clearToasts, flowType, navigate]
  );

  return navigateWithSearch;
}

export { useNavigateWithSearch };
export type { NavigateWithSearchOptions };
